import React from 'react';
import { useForm } from 'react-hook-form';
import ModalForm from '@components/common/hooks/useFormModal/ModalForm';
import CompleteEventFields from '@components/ContentComponents/Events/CompleteEvent/CompleteEventFields';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

const CompleteEventModal = ({
  onSubmit,
  submitRef,
  event,
}) => {
  const form = useForm({
    mode: 'onSubmit',
    values: {
      comments: event.comments,
    },
  });

  return (
    <ModalForm
      form={form}
      onSubmit={onSubmit}
      submitRef={submitRef}
    >
      <Grid container spacing={1} padding="0 8px 8px">
        <Grid x={12}>
          <CompleteEventFields form={form} />
          <Typography variant="body1" sx={{ marginTop: '16px' }}>
            Are you sure you want to mark this event as complete?
          </Typography>
        </Grid>
      </Grid>
    </ModalForm>
  );
};

export default CompleteEventModal;
